module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/root//btn-harvest.png?v=a85ebc5d";